<template>
    <div class="result-category">
        <div class="title-8 line12 boldFont fontSmooth p10-15 borderBottom">{{ title }}</div>
        <div>
            <slot name="link" v-for="item in items" :item="item">
                {{ item }}
            </slot>
        </div>
        <a :href="action" class="more-button" v-if="amount > 3">Bekijk alle {{ amount }} {{ title.toLowerCase() }}</a>
    </div>
</template>

<script>
export default {
    name: "HeaderSearchCategory",
    props:{
        items: {
            required: true,
            type: Array,
        },
        title: {
            required: true,
            type: String,
        },
        amount: {
            required: true,
            type: Number,
        },
        action: {
            required: true,
            type: String,
        }
    }
}
</script>

<style scoped>

</style>
